import React from "react";
import Slider from "react-slick";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";

import FlightSearchForm from "../../components/flight-search-form/FlightSearchForm.component";
import moment from "moment";
import BannerSearch from "../../components/Homebanner/BannerSearch";
import "./Homepage.styles.css";
import { useNavigate } from "react-router-dom";
import { phoneNum } from "../../utils/globalVars";

import bgImgse from "../../app/images/Rectangle 2.jpg";
import serviceImg from "../../app/images/services-background.png";
import testiImg from "../../app/images/testimonials-back.png";

const HomePage = () => {
  const navigate = useNavigate();

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleExpClick = (origin, dest) => {
    navigate({
      pathname: "/flights",
      search: `?search_t=${moment().unix()}&tripType=one-way&dep_loc=${origin}&dest_loc=${dest}&dep_dt=${moment().format(
        "YYYY-MM-DD"
      )}&ret_dt=null&fl_cl=ECONOMY&adt=1&chd=0`,
    });
  };

  const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
  };
  const sliderSettings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    autoplay: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ],
  };
  return (
    <React.Fragment>
      <div
        className="banner-section bg-layer"
      >
        <div className="container">
          <div className="grid-2 align-center">
            <div className="column-40">
              <h4>Planning a trip?</h4>
              <h1>Book your travel at the lowest air fare</h1>
              <p>Easily compare and book your next flight</p>
            </div>
            <div className="column-60">
              <BannerSearch />
            </div>
          </div>
        </div>
      </div>

      <div className="offer-section">
        <div className="container">
          <h4>Choose your place</h4>
          <h2>
            Popular <span>Tours</span>
          </h2>
        </div>
        <div className="container">
          <div className="tours-list">
            <div
              className="tours-inner-50"
              onClick={(e) => handleExpClick("MLE", "JFK")}
            >
              <a href="#">
                <img src="./images/maldives.png" alt="" />
                <p>Maldives Tour</p>
              </a>
            </div>
            <div
              className="tours-inner-25"
              onClick={(e) => handleExpClick("MXP", "LHR")}
            >
              <a href="#">
                <img src="./images/rome.png" alt="" />
                <p>Rome</p>
              </a>
            </div>
            <div
              className="tours-inner-25"
              onClick={(e) => handleExpClick("NCE", "MXP")}
            >
              <a href="#">
                <img src="./images/france.png" alt="" />
                <p>France</p>
              </a>
            </div>
            <div
              className="tours-inner-25"
              onClick={(e) => handleExpClick("NVT", "MXP")}
            >
              <a href="#">
                <img src="./images/brazil.png" alt="" />
                <p>Brazil</p>
              </a>
            </div>
            <div
              className="tours-inner-25"
              onClick={(e) => handleExpClick("YXC", "DEL")}
            >
              <a href="#">
                <img src="./images/canada.png" alt="" />
                <p>Canada</p>
              </a>
            </div>
            <div
              className="tours-inner-50"
              onClick={(e) => handleExpClick("HBE", "BOS")}
            >
              <a href="#">
                <img src="./images/egypt.png" alt="" />
                <p>Egypt Tour</p>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div
        className="services-section"
        style={{ backgroundImage: `url('${serviceImg}')` }}
      >
        <div className="container">
          <div className="services-offer">
            <div className="offered-services">
              <div className="service-img">
                <img src="./images/plane.png" alt="" />
              </div>
              <div className="arrow-img1">
                <img src="./images/arrow.png" alt="" />
              </div>
              <div className="services-text">
                <h3>768</h3>
                <p>Flight Booking</p>
              </div>
            </div>

            <div className="offered-services">
              <div className="service-img">
                <img src="./images/location.png" alt="" />
              </div>
              <div className="arrow-img2 shimmer">
                <img
                  className="stroke animate"
                  src="./images/arrow2.png"
                  alt=""
                />
              </div>
              <div className="services-text">
                <h3>6072</h3>
                <p>Distance Covered</p>
              </div>
            </div>
            <div className="offered-services">
              <div className="service-img">
                <img src="./images/happy.png" alt="" />
              </div>
              <div className="arrow-img3">
                <img src="./images/arrow.png" alt="" />
              </div>
              <div className="services-text">
                <h3>693</h3>
                <p>Happy Customers</p>
              </div>
            </div>
            <div className="offered-services">
              <div className="service-img">
                <img src="./images/dollar.png" alt="" />
              </div>
              <div className="services-text">
                <h3>10978</h3>
                <p>Dollar Saved</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="offer-section minute-offer">
        <div className="container">
          <h4>Top Destination</h4>
          <h2>
            Popular <span>Destination</span>
          </h2>
        </div>
        <div className="container">
          <div className="" id="minuteOffer">
            <Slider {...sliderSettings}>
              <div>
                <div className="column">
                  <div
                    className="col-inner"
                    onClick={(e) => handleExpClick("BAQ", "ABJ")}
                  >
                    <a href="#" className="image-box">
                      <img src="images/colorado-1.png" alt="" />
                      <p>Colombia</p>
                    </a>
                  </div>
                </div>
              </div>
              <div>
                <div className="column">
                  <div
                    className="col-inner"
                    onClick={(e) => handleExpClick("RIC", "BOS")}
                  >
                    <a href="#" className="image-box">
                      <img src="images/verginia-1.png" alt="" />
                      <p>Virginia</p>
                    </a>
                  </div>
                </div>
              </div>
              <div>
                <div className="column">
                  <div
                    className="col-inner"
                    onClick={(e) => handleExpClick("AGP", "ABJ")}
                  >
                    <a href="#" className="image-box">
                      <img src="images/spain.png" alt="" />
                      <p>Spain</p>
                    </a>
                  </div>
                </div>
              </div>
              <div>
                <div className="column">
                  <div
                    className="col-inner"
                    onClick={(e) => handleExpClick("HND", "ABV")}
                  >
                    <a href="#" className="image-box">
                      <img src="images/Japan.png" alt="" />
                      <p>Japan</p>
                    </a>
                  </div>
                </div>
              </div>
            </Slider>
          </div>
        </div>
      </div>

      <div className="testimonials-section">
        <div className="container grid-2">
          <div className="testi-head column">
            <h2>
              We Provide Best Deal <br /> Book now & Enjoy...{" "}
            </h2>
            <p>
              <i class="fa fa-phone" aria-hidden="true"></i>(855) 738-1940
            </p>
          </div>
          <div className="testi-slider column">
            <div className="testi-slide">
              <div className="slider-text">
                <h4>TESTIMONIALS</h4>
                <h2>
                  Travelers <span>Rating</span>
                </h2>
              </div>
              <div id="tetimonials-sliders">
                <Slider {...settings}>
                  <div className="slider-content">
                    <p>
                      I recently used Trianfly to book my flight, and I couldn't
                      be happier with the experience. The website's
                      user-friendly interface made the whole process a breeze. I
                      quickly found the best flight options for my trip, and the
                      competitive pricing saved me some extra bucks.
                    </p>
                    <div className="customer-details">
                      <div className="customer-image">
                        <img src="./images/customer.png" alt="" />
                      </div>
                      <div className="customer-name">
                        <i class="fa fa-star" aria-hidden="true"></i>
                        <i class="fa fa-star" aria-hidden="true"></i>
                        <i class="fa fa-star" aria-hidden="true"></i>
                        <i class="fa fa-star" aria-hidden="true"></i>
                        <i class="fa fa-star" aria-hidden="true"></i>
                        <h5>Katherin West</h5>
                      </div>
                    </div>
                  </div>
                  <div className="slider-content">
                    <p>
                      I recently used trianfly to plan a last-minute trip, and I couldn't be more thrilled with the experience! The website's user-friendly interface made the entire booking process a breeze. From entering my travel details to choosing the perfect flight, everything was straightforward and efficient.
                    </p>
                    <div className="customer-details">
                      <div className="customer-image">
                        <img src="./images/customer-1.png" alt="" />
                      </div>
                      <div className="customer-name">
                        <i class="fa fa-star" aria-hidden="true"></i>
                        <i class="fa fa-star" aria-hidden="true"></i>
                        <i class="fa fa-star" aria-hidden="true"></i>
                        <i class="fa fa-star" aria-hidden="true"></i>
                        <i class="fa fa-star" aria-hidden="true"></i>
                        <h5>Mark Ford</h5>
                      </div>
                    </div>
                  </div>
                  <div className="slider-content">
                    <p>
                      I have been a loyal customer of trianfly website for several years, and it never fails to amaze me with its fantastic deals and top-notch customer service!
                    </p>
                    <div className="customer-details">
                      <div className="customer-image">
                        <img src="./images/customer-2.png" alt="" />
                      </div>
                      <div className="customer-name">
                        <i class="fa fa-star" aria-hidden="true"></i>
                        <i class="fa fa-star" aria-hidden="true"></i>
                        <i class="fa fa-star" aria-hidden="true"></i>
                        <i class="fa fa-star" aria-hidden="true"></i>
                        <i class="fa fa-star" aria-hidden="true"></i>
                        <h5>Henary Williams</h5>
                      </div>
                    </div>
                  </div>
                </Slider>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default HomePage;
